export default __webpack_public_path__ + "images/27c77b3831fe6c97809c502c36042ac6-books.webp";